var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPhone = function SvgPhone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    fill: "none",
    viewBox: "0 0 28 28"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#1E1E1E",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M9.777 10.329a17 17 0 0 0 3.32 4.678 17 17 0 0 0 4.679 3.32c.145.07.218.105.31.132a1.22 1.22 0 0 0 1.006-.171c.078-.056.145-.123.278-.256.408-.408.612-.612.817-.745a2.33 2.33 0 0 1 2.543 0c.206.133.41.337.817.745l.228.227c.62.62.93.93 1.098 1.263a2.33 2.33 0 0 1 0 2.107c-.168.332-.478.642-1.098 1.262l-.184.184c-.618.618-.927.927-1.347 1.163a3.94 3.94 0 0 1-1.725.449c-.481-.002-.81-.095-1.47-.282a22.2 22.2 0 0 1-9.664-5.686A22.2 22.2 0 0 1 3.7 9.055c-.187-.659-.28-.988-.282-1.47a3.94 3.94 0 0 1 .448-1.724c.236-.42.545-.73 1.163-1.347l.184-.184c.62-.62.93-.93 1.263-1.098a2.33 2.33 0 0 1 2.106 0c.333.168.643.478 1.263 1.098l.228.227c.408.408.612.612.745.817.503.774.503 1.77 0 2.544-.133.205-.337.409-.745.817-.134.133-.2.2-.256.278a1.22 1.22 0 0 0-.172 1.005c.027.093.062.165.132.31"
  })));
};
export default SvgPhone;